import { Component, OnInit } from "@angular/core";
import { Level } from "../../shared/enums/level.enum";
import { Dispersion } from 'src/app/shared/models/dispersions';
import { User } from '../../shared/models/users';
import { UserRequest } from "../../shared/models/userRequest";
import { UsersService } from 'src/app/shared/services//users.service';
import { UtilitiesService } from "src/app/shared/services/utilities.service";
import { UserRequestService } from "src/app/shared/services/user-request.service";
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
@Component({
  selector: "app-user-request",
  templateUrl: "./user-request.component.html",
  styleUrls: ["./user-request.component.scss"],
})
export class UserRequestComponent implements OnInit {
  cdta: any;
  udata: any;
  idCompany: string;
  companyName: string;
  newDispersion: Dispersion;
  userData: User;
  tempBeneficiaries: any = [];
  tempDateScheduled: any;
  listRequest: UserRequest[] = [];

  constructor(
    private utilitiesService: UtilitiesService,
    private userRequestService: UserRequestService,
    private userService: UsersService,
    private dispersionsService: DispersionsService
  ) {}

  ngOnInit(): void {
    this.udata = this.utilitiesService.getUserData();
    this.cdta = this.utilitiesService.getCompanyData();
    this.idCompany = this.cdta.id;
    this.companyName = this.cdta.companyLegalName;
    console.log(this.cdta);
    switch (this.udata.level) {
      case Level.ihunterSuperUser:
        this.getListRequest();
        break;
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        break;
      case Level.CompanyAdmin:
        this.getListRequest();
        break;
      default:
        break;
    }
  }

  async getListRequest(){
    this.listRequest = await this.userRequestService.getUserRequest(this.cdta.id, "");
  }

  dowloadVoucher(link: any, event: any) {
    event.preventDefault();
    this.utilitiesService.downloadFile(link.url, link.name);
  }

  parseFiles(urls: string = '') {
    return urls.split(',').filter(f => f).map(u => Object({ url: u.trim(), name: u.substring(u.lastIndexOf('/') + 1) }));
  }
  
  changeStatusRequest(data,id,status,idUsuario,feesParam,taxParam,granTotalParam,email,dispersionAmount){
    if(status == 2){  
      this.userRequestService.updateStatusRequest(id,status,email,dispersionAmount,data.userName).subscribe(resultUpdateStatus => {
        this.utilitiesService.notifyMe('Estatus actualizado!', 'success');
        console.log(resultUpdateStatus);

        this.newDispersion = new Dispersion();
        this.newDispersion.dateCreated = this.utilitiesService.dateToNumber(new Date());
        this.newDispersion.beneficiaries = [];

        let userData = this.userService.getUserAsPromise(idUsuario).then(user => {
          this.userData = user;
          var userObj : any [] = [];
          userObj[0] ={ amount : 0 , cardNumber : '' , employeeName: '' , idUsuario: '' , email: '' }; 
          this.newDispersion.dispersionAmount += dispersionAmount;
          userObj[0].amount = dispersionAmount;
          userObj[0].cardNumber = data.cardNumber;
          userObj[0].employeeName = data.userName;
          userObj[0].idUsuario = idUsuario;
          userObj[0].email = email;
          this.newDispersion.beneficiaries.push(userObj[0]);
      
          // ******************  CALCULO DE MONTOS, FEES, IVA **********************
          var fees = parseFloat(feesParam.toString()).toFixed(2);
          var tax = parseFloat(taxParam.toFixed(2));
          var granTotal = parseFloat(granTotalParam.toString()).toFixed(2);

          this.newDispersion.fees = parseFloat(fees);
          this.newDispersion.tax = tax;
          this.newDispersion.granTotal = parseFloat(granTotal);

          // ********** valores adicionales al objeto de la dispersion.
          this.newDispersion.companyId = this.idCompany;
          this.newDispersion.companyName = this.companyName;
          if (!this.newDispersion.dateScheduled) {
            this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(new Date());
          }
          if (this.tempDateScheduled) {
            this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(this.tempDateScheduled);
          }        

          this.dispersionsService.newDispersion(this.newDispersion).then(data => {

          });

        }).catch(error => {
          console.log(error);
        })      
      }); 
      
      //location.reload();
    }else if(status == 4){
      this.userRequestService.updateStatusRequest(id,status,email,dispersionAmount,data.userName).subscribe(resultUpdateStatus => {
        this.utilitiesService.notifyMe('Estatus actualizado!', 'success');
        console.log(resultUpdateStatus);
      });
      location.reload();
    }else if(status == 1){
      this.userRequestService.updateStatusRequest(id,status,email,dispersionAmount,data.userName).subscribe(resultUpdateStatus => {
        this.utilitiesService.notifyMe('Estatus actualizado!', 'success');
        console.log(resultUpdateStatus);
      });
      location.reload();
    }
  }
}
